module.exports = __webpack_public_path__ + "img/wallet_mb_06.b176ca48.png";